module.exports = __webpack_public_path__ + "img/zhaob.2db65997.png";